export const demoData = {
  seoText: 'Joy Sample Wedding - See a Joy Wedding Website in Action',
  firstCouple: {
    title: 'Meet Amy & Dave',
    content:
      'Meet Amy and Dave—our very first Joy couple. They hold a special place in our hearts, as do most firsts (first kiss, first love, first…well, you know). Joy actually started when Amy and Dave asked us to help them celebrate with friends and family near and far, and now you can relive their special moments!',
  },
  website: {
    title: 'Their Website',
    content:
      'Check out their wedding website on both our <a target="blank" href="https://withjoy.com/amyplusdave">single-page</a> and <a target="blank" href="https://withjoy.com/amyanddave/welcome">multi-page</a> layouts and <a href="#downloadTheApp">download Joy</a> to see their app! Use their event password, <i>AmyPlusDave</i>, to view the private sections of their website.',
    eventPassword: 'Event Password',
    altTextSinglePage: 'Visit Amy and Dave’s Single-Page Website',
    altTextMultiPage: 'Visit Amy and Dave’s Multi-Page Website',
  },
  app: {
    title: 'Their App',
    content:
      'Try out Amy and Dave’s wedding app as if you were one of their guests. Download Joy for iOS or Android, click Join an Event, and input their event password.',
    altText: 'Mobile application preview',
    eventPassword: 'Event Password',
    download: 'Download',
    downloadContent: 'Joy for iOS and Android',
    altTextAppStore: 'Download application on the App Store',
    altTextGooglePlay: 'Download application on the Google Play',
  },
} as const;
